import "antd/dist/reset.css";
import { Collapse,Empty, Descriptions, message } from "antd";
import React from "react";
import utils from "utils";
import "./SOSSummaryChild.scss";
import api from "utils/api";
import Loader from "Components/Loader";

const { Panel } = Collapse;


class ConcogSummary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           result : {},
        educationalLevel:"",
        isLoading: false,
        }
       
    }
    componentDidMount()
    {   
        this.getConcogAnswerDetails();
    }

getConcogAnswerDetails() {
    this.setState({ isLoading: true });
    let data={
        patient_id: this.props.data?.patient_id,
        type: this.props.data?.user_type,  
    }
    api
      .get_concog_summary_list(data)
      .then((res) => {
        if (res.data?.status == 200) {
            this.setState({ result: res.data, isLoading: false, });
        }else{
            message.error(res.data?.message, ErrorDuration);
            this.setState({isLoading: false})
        }
      })
      .catch((err) => {this.setState({isLoading: false}) });
}

    copyLooping(data,education)
    {
        if(education=="Elementary"|| education=="Primary")
        {
            return(
                <>
                {data.edu_less_than_10years.values.map((value)=>{
                    return(
                        <div>{value.label}</div>
                    )
                })}
                </>
            )  
        }
        else
        {
            return(
                <>
                {data.edu_greater_than_10years.values.map((value)=>{
                    return(
                        <div>{value.label}</div>
                    )
                })}
                </>
            )  
        }
       
    }
    verbalLooping(data,education)
    {
        if(education=="Elementary"|| education=="Primary")
        {
            return(
                <>
                {data.edu_less_than_10years.values.map((value)=>{
                    return(
                        <div>{value}</div>
                    )
                })}
                </>
            )  
        }
        else
        {
            return(
                <>
                {data.edu_greater_than_10years.values.map((value)=>{
                    return(
                        <div>{value}</div>
                    )
                })}
                </>
            )  
        }
       
    }
    fiveWordsLoop(values)
    {
        return(
            <>
            <div style={{display:"grid", gridTemplateColumns:"auto auto"}}>
                <div style={{display:"grid"}}>
                    <span style={{fontWeight:"bold"}}>Free Recall</span>
                    {  Object.entries(values || {}).map(([dataKeys, dataValue],i)=>{
            return(
                <>             
                        <span>{dataValue.label}</span>                        
                </>
            )
           })}
                </div>
                <div style={{display:"grid"}}>
                    <div style={{fontWeight:"bold"}}>Recognition</div>
                    <div>{  Object.entries(values || {}).map(([dataKeys, dataValues],i)=>{
            return(
                <>
                <div style={{display:"flex"}}>
                {dataValues.values.map((words)=>{
                    return(
                       <div>{words}, {" "}</div>
                    )
                })}
                </div>                
                </>
            )
           })}</div>
                </div>
            </div>
           
            </>
        )
       
    }


    summaryList(data)
    {
        let educationallevel="";
        return( 
        Object.entries(data.values.concog || {}).map(([FormItemKey, FormItemData],i) => 
        {
            if(FormItemData.label=="Education Level")
            {
                FormItemData.values.map((options)=>{
                    if(options.is_selected)
                    {
                        educationallevel=options.label
                    }
                })
            }
            return( FormItemData.notes !== null && <div>
                <Descriptions
                bordered
                size="middle"
                contentStyle={{width:"35%"}}
                labelStyle={{width:"65%"}}>
                    {FormItemData.label=="Education Level"?
                     <Descriptions.Item label={<span style={{fontWeight:"bold"}}>{FormItemData.label}</span>}>
                        {educationallevel}
                     </Descriptions.Item>:null}
                     {((FormItemData.label=="Naming" || FormItemData.label=="Imitation of hand gestures")&& FormItemData.notes !== null)?
                      <Descriptions.Item label={
                     <div style={{display:"grid"}}>
                     <span style={{fontWeight:"bold"}}>{FormItemData.label}</span>
                     {FormItemData.values.map((names,i)=>{
                        return(<>{names}, </>)
                     })}
                     </div>}>
                        {FormItemData.notes}
                     </Descriptions.Item>:null}
                     {FormItemData.label=="Registration of five words" ?
                     <Descriptions.Item label={
                     <div style={{display:"grid"}}>
                     <span style={{fontWeight:"bold"}}>{FormItemData.label}</span>                     
                     </div>}>
                     {FormItemData.values.map((names,i)=>{
                        return(<>{names}, </>)
                     })}
                     
                     </Descriptions.Item>:null}
                     {(FormItemData.title=="Copying" && FormItemData.notes !== null)?
                     <Descriptions.Item label={<div>
                        <span style={{fontWeight:"bold"}}>{FormItemData.title}</span>
                        {this.copyLooping(FormItemData.values,educationallevel)}       
                     </div>}>{FormItemData.notes}</Descriptions.Item>:null}
                     {(FormItemData.title=="Verbal Fluency" && FormItemData.notes !== null)?
                     <Descriptions.Item label={<div>
                        <span style={{fontWeight:"bold"}}>{FormItemData.title}</span>
                        {this.verbalLooping(FormItemData.values,educationallevel)}       
                     </div>}>{FormItemData.notes}</Descriptions.Item>:null}
                     {(FormItemData.title=="Recall of five words" && FormItemData.notes !== null)?
                     <Descriptions.Item label={<div>
                        <span style={{fontWeight:"bold"}}>{FormItemData.title}</span>
                        {this.fiveWordsLoop(FormItemData.values)}       
                     </div>}>{FormItemData.notes}</Descriptions.Item>:null}
                   
                </Descriptions>
        </div>)           
        })
    )
        
    }
   
    render()
    {
        return (
    
            <>
            {this.state.isLoading ? (
                    <Loader />
             ) : (
             <div className="mhe-wrapper-container">
                    <div className="mhe-header">
                      <div>CONCOG</div>
                    </div>
        
                    <div className="mhe-content">
                      {this.state?.result?.data?.count == 0 ? (
                        <Empty
                          description={"No Data"}
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                        />
                      ) : (              
                         <Collapse
                        style={{ overflowY: "auto" }}
                        bordered={false}
                        expandIconPosition="start"
                        ghost={true}
                        className="mhe-list-container"
                        >
                            {this.state?.result?.data?.results.map((data,i)=>{
                                return(
                                    <Panel key={i}
                                    header={
                                    <div>
                                        {utils.FormatDate(data?.completion_date, "DATE_14")},{" "}
                                        {utils.FormatDate(data?.completion_date, "TIME_1")}{"  "}{data?.values?.scores?.total_score!==null?<span style={{color: data?.values?.scores?.total_score <= 9 ? "#bf360d": data?.values?.scores?.total_score <= 19 ? "#ffb74d" : data?.values?.scores?.total_score <= 29 ? "#4caf51" : "#357a38", fontWeight:"700"}}>{`(${data?.values?.scores?.level||""}  ${data?.values?.scores?.total_score||"0"}/${data?.values?.scores?.overall_score})`}</span>:null}
                                    </div>
                                    }
                                    extra={utils.FirstNameLastName(utils.salutationPrefixName(data?.doctor_salutation,utils.getDisplayName(data?.consultation_doctor, data?.doctor_last_name)), "250px")}
                                >
                                   {this.summaryList(data)}                                              
                                </Panel>
                                )
                            })}
                           

                        </Collapse>
                       
                      )}
                    </div>
                  </div>
            )}
            </>
          )
    }
 
};

export default ConcogSummary;
